<template>
  <div class="ShowUser">

    <user-breadcrumbs :items="[{text: 'Profile'}]">
    </user-breadcrumbs>

    <!--<user-role-badge :user="user">
    </user-role-badge>-->

    <user-toolbar :user="user">
    </user-toolbar>

    <v-form disabled>
      <user-form-basic-info :form="form">
      </user-form-basic-info>
    </v-form>

  </div>
</template>
<script>
import metaService from "../../services/metaService";
import store from "../../store";
import UserRoleBadge from "./components/UserRoleBadge";
import UserBreadcrumbs from "./components/UserBreadcrumbs";
import UserToolbar from "./components/UserToolbar";
import UserFormBasicInfo from "./components/UserFormBasicInfo";
import userService from "../../services/userService";

export default {
  components: {UserFormBasicInfo, UserToolbar, UserBreadcrumbs, UserRoleBadge},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', this.user.name);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Users', exact: true, to: {name: 'users'},},
        {text: 'Show User'}
      ],
      form: userService.initForm(),
    }
  },
  created() {
    userService.initFormForUser(this.form, this.user);
  }
}
</script>
